// extracted by mini-css-extract-plugin
export default {"container":"oL4hxz","header":"zUJMIZ","closeIcon":"jvJXXY"};